import React, { useEffect, useState } from "react";
import styles from "./liveFeedSec.module.css";
import { FaLinkedinIn, FaInstagram, FaTiktok, FaFacebookF } from "react-icons/fa";

const LiveFeedsHead = () => {
    const [filter, setFilter] = useState("all");

    const feeds = [
        // { type: "linkedin", widgetId: "YOUR_LINKEDIN_WIDGET_ID" },
        { type: "instagram", widgetId: "9cbe123e-6bcc-472f-b112-8d60b11615b9" },
        // { type: "tiktok", widgetId: "YOUR_TIKTOK_WIDGET_ID" },
        // { type: "facebook", widgetId: "YOUR_FACEBOOK_WIDGET_ID" },
    ];

    const filteredFeeds =
        filter === "all" ? feeds : feeds.filter((feed) => feed.type === filter);

    const reloadScript = () => {
        if (window.ElfsightWidget) {
            console.log("Reinitializing Elfsight widgets...");
            window.ElfsightWidget.init();
        } else {
            const script = document.createElement("script");
            script.src = "https://apps.elfsight.com/p/platform.js";
            script.defer = true;
            document.body.appendChild(script);
            script.onload = () => {
                console.log("Elfsight script loaded, initializing widgets...");
                if (window.ElfsightWidget) {
                    window.ElfsightWidget.init();
                }
            };
        }
    };

    useEffect(() => {
        console.log("Filter changed:", filter);
        console.log("Filtered feeds:", filteredFeeds);
        reloadScript();
    }, [filter]);

    return (
        <div className={styles.lf_feeds}>
            <div className={styles.lf_Head}>
                <h2>Live</h2>
                <div className={styles.lf_Filters}>
                    <button
                        className={filter === "all" ? styles.active : ""}
                        onClick={() => setFilter("all")}
                        title="All"
                    >
                        All
                    </button>
                    {/* <button
                        className={filter === "linkedin" ? styles.active : ""}
                        onClick={() => setFilter("linkedin")}
                        title="LinkedIn"
                    >
                        <FaLinkedinIn />
                    </button> */}
                    <button
                        className={filter === "instagram" ? styles.active : ""}
                        onClick={() => setFilter("instagram")}
                        title="Instagram"
                    >
                        <FaInstagram />
                    </button>
                    {/* <button
                        className={filter === "tiktok" ? styles.active : ""}
                        onClick={() => setFilter("tiktok")}
                        title="TikTok"
                    >
                        <FaTiktok />
                    </button>
                    <button
                        className={filter === "facebook" ? styles.active : ""}
                        onClick={() => setFilter("facebook")}
                        title="Facebook"
                    >
                        <FaFacebookF />
                    </button> */}
                </div>
            </div>
            <div className={styles.lf_Grid}>
                {filteredFeeds.map((feed, index) => (
                    <div key={index} className={styles.lf_Card}>
                        {/* Render Elfsight widget */}
                        <div className={`elfsight-app-${feed.widgetId}`}></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LiveFeedsHead;
